<script>
    import { Route, Router } from "svelte-routing";
    import MembershipPrintForm from "../../components/Forms/MembershipPrint/MembershipPrintForm.svelte";
    import MembershipPrintTable from "../../components/Cards/Print/MembershipPrintTable.svelte";
    export let location;
</script>

<Router url="prints">
    <Route path="/" component="{MembershipPrintTable}" />
    <Route path="/edit/:id" let:params>
        <MembershipPrintForm membershipPrintId="{params.id}" />
    </Route>
    <Route path="/create" component="{MembershipPrintForm}" />
</Router>
